import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { ModalFooterComponent } from '@shared/components/modal-footer/modal-footer.component';
import { TranslatePipe } from '@core/pipes';
import { AsyncPipe } from '@angular/common';
import { DialogRef } from '@angular/cdk/dialog';
import { ButtonComponent } from '@shared/components/button/button.component';
import { SvgComponent } from '@shared/components/svg/svg.component';
import { Substitutions } from '@selfcare/cms';

@Component({
  selector: 'sc-simcard-swap-physical-modal',
  imports: [
    ModalComponent,
    ButtonComponent,
    ModalFooterComponent,
    SvgComponent,
    TranslatePipe,
    AsyncPipe,
  ],
  templateUrl: './simcard-swap-physical-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimcardSwapPhysicalModalComponent {
  public readonly Substitutions = Substitutions;

  constructor(private readonly dialogRef: DialogRef<boolean>) {}

  public close(approved: boolean = false) {
    this.dialogRef.close(approved);
  }
}
